export const FEATURE_KEY = 'inbox-agent-calls';

/** Route segment for the voice-agent Agent Calls view. */
export const AGENT_CALLS_PATH = 'inbox/agent-calls';

/** Category (and card tag) of the escalation the mapper synthesizes for an
 *  escalated call — a placeholder until the voice agent has a real handoff. Kept
 *  as data in English; the UI shows it as `category.support`. */
export const SUPPORT_CATEGORY = 'Support';

/** Confidence shown on that synthesized escalation — a placeholder, not a model score. */
export const ESCALATION_PLACEHOLDER_CONFIDENCE = 80;
